// extracted by mini-css-extract-plugin
export default {"menuContainer":"VerExpedienteCriterios_menuContainer__Tpj9-","menuOption":"VerExpedienteCriterios_menuOption__birfD","selected":"VerExpedienteCriterios_selected__6vlYI"};